import PropTypes from 'prop-types'
import React, { useState} from 'react'
import { useDrop } from '../contexts/DropContext'
import {FaUpload} from "react-icons/fa"
import 'react-tooltip/dist/react-tooltip.css'
import {Tooltip as ReactTooltip} from "react-tooltip"

const ToolTipHeader = ({header, tip})  => {
    var rand_id = Math.floor(Math.random() * 10000); 
    rand_id = rand_id.toString()
    const project = useDrop().currentDrop
    return (
        <>

        <a id={header + rand_id}> {header} </a>           
        <ReactTooltip anchorId={header + rand_id} content={tip} place="top" offset={{top: 1}} opacity={1} />
        </>

     );
}
     
export default ToolTipHeader